var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55_356",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5531 3C15.8329 3 16.1014 3.10377 16.2993 3.28849C16.4972 3.4732 16.6084 3.72373 16.6084 3.98495H18.719C18.9989 3.98495 19.2673 4.08872 19.4652 4.27344C19.6631 4.45815 19.7743 4.70868 19.7743 4.9699C19.7743 5.23113 19.6631 5.48166 19.4652 5.66637C19.2673 5.85108 18.9989 5.95486 18.719 5.95486H6.05531C5.77542 5.95486 5.507 5.85108 5.30909 5.66637C5.11118 5.48166 5 5.23113 5 4.9699C5 4.70868 5.11118 4.45815 5.30909 4.27344C5.507 4.08872 5.77542 3.98495 6.05531 3.98495H8.16592C8.16592 3.72373 8.2771 3.4732 8.47501 3.28849C8.67292 3.10377 8.94134 3 9.22122 3H15.5531Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98462 8.00037H18.789V19.8198C18.789 20.3422 18.5642 20.8433 18.1639 21.2127C17.7637 21.5821 17.2209 21.7897 16.6549 21.7897H8.11868C7.55269 21.7897 7.00989 21.5821 6.60967 21.2127C6.20946 20.8433 5.98462 20.3422 5.98462 19.8198V8.00037ZM9.71923 9.97027C9.57773 9.97027 9.44203 10.0222 9.34198 10.1145C9.24192 10.2069 9.18571 10.3321 9.18571 10.4627V19.3273C9.18571 19.4579 9.24192 19.5832 9.34198 19.6755C9.44203 19.7679 9.57773 19.8198 9.71923 19.8198C9.86073 19.8198 9.99643 19.7679 10.0965 19.6755C10.1965 19.5832 10.2527 19.4579 10.2527 19.3273V10.4627C10.2527 10.3321 10.1965 10.2069 10.0965 10.1145C9.99643 10.0222 9.86073 9.97027 9.71923 9.97027ZM15.0544 9.97027C14.9129 9.97027 14.7772 10.0222 14.6771 10.1145C14.5771 10.2069 14.5209 10.3321 14.5209 10.4627V19.3273C14.5209 19.4579 14.5771 19.5832 14.6771 19.6755C14.7772 19.7679 14.9129 19.8198 15.0544 19.8198C15.1959 19.8198 15.3316 19.7679 15.4316 19.6755C15.5317 19.5832 15.5879 19.4579 15.5879 19.3273V10.4627C15.5879 10.3321 15.5317 10.2069 15.4316 10.1145C15.3316 10.0222 15.1959 9.97027 15.0544 9.97027Z",
    fill: "#3A3A3A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.cb848eb7688d291edecd37c73cfe08cd.svg";
export { ForwardRef as ReactComponent };